/** The most spots one parking can have. */
export const MAX_NUMBER_OF_SPOTS = 100 as const;
